import { useTranslation } from 'react-i18next'

import { useScreen } from '../../../hooks'
import { FormModalContainer, useCloseConfirm } from '../../Form'
import { useResizeModal } from '../../Modal'
import { ContractForm } from '../ContractForm'

import { QA_NAME_CONTRACT_CREATION_MODAL } from './ContractFormModal.constants'

function ContractFormModal({
  titleKey = 'Contract.AddNewTitleKey',
  onClose,
  ...restProps
}) {
  const { t } = useTranslation()

  const { handleClose, isCloseConfirm, setCloseConfirm } = useCloseConfirm({
    onClose,
  })

  const { isMobileScreenSize } = useScreen()

  const { fullScreen, handleResizeModal } = useResizeModal()

  return (
    <ContractForm
      {...restProps}
      FormContainer={FormModalContainer}
      containerProps={{
        isCloseConfirm,
        isFullScreen: isMobileScreenSize || fullScreen,
        qaName: QA_NAME_CONTRACT_CREATION_MODAL,
        setCloseConfirm,
        title: t(titleKey),
        onClose,
        onResize: isMobileScreenSize ? undefined : handleResizeModal,
      }}
      contentComponentProps={{ isFullScreen: isMobileScreenSize || fullScreen }}
      onCancel={handleClose}
      onClose={onClose}
    />
  )
}

export default ContractFormModal
